exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-donut-chart{display:block;position:relative}adp-donut-chart donut-chart{display:block}adp-donut-chart .c3-chart-arcs-title{font-family:ProximaNova-Regular,Arial,Helvetica,sans-serif}adp-donut-chart .c3-chart-arcs-title .chart-value{font-size:32px;fill:#0e5061}adp-donut-chart .c3-chart-arcs-title .chart-label{font-size:15px;fill:#000}adp-donut-chart .donut-bkg{position:absolute;top:0;left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpDonutChart/adpDonutChart.less
// module id = 678
// module chunks = 0